import React, { useState, useRef, useEffect } from 'react';
import './Menu.css';
import logo from '../../assets/vedi_black.png'

const menuData = [
  {
    title: "PREDJELA / APPETIZERS",
    items: [
      {
        name: "Goveđa pašteta / Beef pate",
        price: "11,00€",
        description: "Goveđa pašteta 150 g / maslac / marinirani luk / aceto krema / rikola / domaći kruh",
        translation: "Beef pâté 150 g / butter / marinated onion / aceto cream / arugula / homemade bread",
      },
      {
        name: "Pršut i sirevi / Prosciutto and cheese",
        price: "12,88€",
        description: "Dalmatinski pršut 75g / Domaći bilogorski sir 75g / rikola / pesto od rajčice / domaći kruh",
        translation: "Dalmatian prosciutto 75g / cheese 75g / arugula / tomato pesto / homemade bread",
      },
      {
        name: "Goveđi carpaccio / Beef Carpaccio",
        price: "13,88€",
        description: "Govedina 100g / rikola / marinirani luk / pesto / aceto krema / parmezan / domaći kruh",
        translation: "Beef 100g / arugula / marinated onion / pesto / aceto cream / parmesan cheese / homemade bread",
      },
      {
        name: "Dimljena pačja prsa / Smoked duck breast",
        price: "15,88€",
        description: "Dimljena pačja prsa 50g / rukola / file naranče / gel od kestena / kesten u bagremovom medu / dehidrirani kukuruz / domaći kruh",
        translation: "Smoked duck breast 50g / arugula / orange segments / chestnut gel / chestnut in acacia honey / dehydrated corn / homemade bread",
      },
      {
        name: "Goveđi tartar / Beef tartar",
        price: "15,88€",
        description: "Govedina 100g / Začinski maslac / Nori alga / domaći kruh",
        translation: "Beef 100g / Spiced butter / Nori seaweed / homemade bread",
      },
    ],
  },
  {
    title: "JUHA / SOUP",
    items: [
      {
        name: "Goveđa juha / Beef soup",
        price: "5,00€",
        description: "Goveđa juha / gris knedla",
        translation: "Beef soup / dumpling",
      },
      {
        name: "Juha od vrganja / Mushroom soup",
        price: "6,00€",
        description: "Juha od vrganja",
        translation: "Mushroom soup",
      },
      {
        name: "Dnevna juha / Daily soup",
        price: "6,50€",
        description: "",
        translation: "",
      },
    ],
  },
  {
    title: "TJESTENINE / PASTA",
    items: [
      {
        name: "Pljukanci s biftekom / Pljukanci with steak",
        price: "16,00€",
        description: "Pljukanci / Biftek 100g / umak od zelenog papra / sušena rajčica / parmezan",
        translation: "Pljukanci / Steak 100g / green pepper sauce / dried tomato / parmesan cheese",
      },
      {
        name: "Pljukanci s tartufima / Pljukanci with truffles",
        price: "17,00€",
        description: "Pljukanci / svježi tartufi / parmezan",
        translation: "Pljukanci / fresh truffles / parmesan cheese",
      },
      {
        name: "Pljukanci s plodovima morskog dna / Pljukanci with treasures of the seabed",
        price: "19,00€",
        description: "Pljukanci / file tune 30g / file sabljarke 30g / gamberi 30g / škampi 40g / cherry rajčica / krema od škampa / parmezan",
        translation: "Pljukanci / tuna fillet 30g / swordfish fillet 30g / prawns 30g / scampi 40g / cherry tomatoes / scampi cream / parmesan cheese",
      },
      {
        name: "Lingvini s gamberima i kremom od škampa / Linguine with prawns and shrimp cream",
        price: "17,00€",
        description: "Lingvini / gamberi 100g / krema od škampa / cherry rajčica / parmezan",
        translation: "Linguine / gamberi 100g / shrimp cream / cherry tomato / parmesan cheese",
      },
      {
        name: "Lingvini s piletinom / Linguine with chicken",
        price: "15,88€",
        description: "Lingvini / piletina 100g / umak od rajčice / tikvice / paprika / soja sos / vrhnje za kuhanje / parmezan",
        translation: "Linguine / chicken 100g / tomato sauce / zucchini / pepper / soya sauce / cooking cream / parmesan cheese",
      },
    ],
  },
  {
    title: "RIŽOTO / RISOTTO",
    items: [
      {
        name: "Rižoto s piletinom i vrganjima / Chicken and Porcini mushrooms risotto",
        price: "15,88€",
        description: "riža / piletina / pršut / crno vino / parmezan / juha od vrganja",
        translation: "rice / chicken / prosciutto / red wine / parmesan cheese / porcini mushroom soup",
      },
      {
        name: "Vege rižoto / Veggie risotto",
        price: "12,00€",
        description: "riža / paprika / tikvice / cherry rajčica / krema od rajčice / parmezan",
        translation: "rice / pepper / zucchini / cherry tomato / tomato cream / parmesan cheese",
      },
    ],
  },
  {
    title: "GLAVNA JELA / MAIN DISHES",
    items: [
      {
        name: "Ribeye steak",
        price: "31,00€",
        description: "Ribeye steak 250g / pečeni krumpir / povrće sa žara / umak od zelenog papra",
        translation: "Ribeye steak 250g / baked potatoes / grill vegetables / green pepper sauce",
      },
      {
        name: "Ramsteak",
        price: "27,00€",
        description: "Ramsteak 250g / pečeni krumpir / povrće sa žara / umak od zelenog papra",
        translation: "Ramsteak 250g / baked potatoes / grill vegetables / green pepper sauce",
      },
      {
        name: "Biftek / Beefsteak",
        price: "31,00€",
        description: "Biftek 250g / pire od krumpira / kuhano povrće / umak od gorušice",
        translation: "Beefsteak 250g / mashed potatoes / cooked vegetables / mustard sauce",
      },
      {
        name: "Goveđi obrazi u pršutu / Prosciutto wrapped Beef cheeks",
        price: "22,88€",
        description: "Goveđi obrazi 250g / pire od krumpira / kuhano povrće / umak od gorušice / mileram",
        translation: "Beef cheeks 250g / mashed potatoes / cooked vegetables / mustard sauce / sour cream",
      },
      {
        name: "Grill piletina / Grilled chicken",
        price: "15,88€",
        description: "Grill piletina 250g / pečeni krumpir / parmezan umak / rikola",
        translation: "Grilled chicken 250g / baked potatoes / parmesan sauce / arugula",
      },
      {
        name: "Svinjska rebarca / Pork ribs",
        price: "19,88€",
        description: "Svinjska rebarca 600g / dolar čips / pigi sos (slatko/kiselo/pikantni premaz od paprike) / umak od zelenog papra",
        translation: "Pork ribs 600g / dollar chips / pigi sauce (sweet/sour/spicy peppers coating) / green pepper sauce",
      },
      {
        name: "Vedi grill",
        price: "15,88€",
        description: "kobasica 70g / govedina 70g / piletina 70g / svinjetina 70g / pečeni krumpir / đuveč riža / umak od zelenog papra",
        translation: "sausage 70g / beef 70g / chicken 70g / pork 70g / baked potatoes / đuveč rice / green pepper sauce",
      },
      {
        name: "Smash burger",
        price: "12,88€",
        description: "govedina 150g / cheddar sir / domaći umak / karamelizirani luk / kiseli krastavci / dolar čips",
        translation: "beef 150g / cheddar cheese / homemade sauce / caramelized onions / pickles / dollar chips",
      },
      {
        name: "Teleća rebra / Veal ribs",
        price: "27,00€",
        description: "Teleća rebra cca 500g / pire od krumpira / kuhano povrće / umak od crnog vina",
        translation: "Veal ribs approx. 500g / mashed potatoes / boiled vegetables / red wine sauce",
      },
      {
        name: "Janjeći rump / Lamb rump",
        price: "27,00€",
        description: "Janjeći rump / pire od krumpira / kuhano povrće / umak od crnog vina / žute ljuskavice (gljive)",
        translation: "Lamb rump / mashed potatoes / boiled vegetables / red wine sauce / yellow scalycap (mushrooms)",
      },
    ],
  },
  {
    title: "POSEBNA PONUDA / SPECIAL OFFER",
    items: [
      {
        name: "Dry age steak",
        price: "14,88€",
        description: "Dry age Angus steak 100g / pire krumpir / povrće sa žara / kuhano povrće / dolar čips / umak od zelenog papra / umak od gorušice",
        translation: "Dry age Angus steak 100g / mashed potatoes / grilled vegetables / boiled vegetables / dollar chips / green pepper sauce / mustard sauce",
      },
      {
        name: "Wagyu A5 Japan-Kagoshima",
        price: "33,00€",
        description: "Wagyu steak 100g / pire od krumpira / povrće s grila / umak od zelenog papra",
        translation: "Wagyu steak 100g / mashed potatoes / grilled vegetables / green pepper sauce",
      },
    ],
  },
  {
    title: "RIBA / FISH",
    items: [
      {
        name: "File Brancina / Sea bass fillet",
        price: "18,88€",
        description: "File Brancina 200g / pire od krumpira / kuhano povrće / krema od celera",
        translation: "Sea bass fillet 200g / mashed potatoes / cooked vegetables / celery cream",
      },
      {
        name: "Tuna Steak",
        price: "18,88€",
        description: "Odrezak tune 250g / kuhana blitva s krumpirom",
        translation: "Tuna steak 250g / boiled Swiss chard with potatoes",
      },
      {
        name: "File Sabljarke / Swordfish fillet",
        price: "19,88€",
        description: "File Sabljarke 250g / kuhana blitva s krumpirom / krema od pastrnjaka / riblji veloute",
        translation: "Swordfish fillet 250g / boiled Swiss chard with potatoes / parsnip purée / fish velouté",
      },
    ],
  },
  {
    title: "DJEČJI MENI / KIDS MENU",
    items: [
      {
        name: "Lingvini Napolitana / Linguine Napolitana",
        price: "10,00€",
        description: "Lingvini / umak od rajčice / maslac",
        translation: "Linguine / tomato sauce / butter",
      },
      {
        name: "Panirani pileći fritesi s pire krumpirom / Breaded chicken strips with mashed potatoes",
        price: "10,00€",
        description: "Fritesi 150g / pire krumpir",
        translation: "Chicken strips 150g / mashed potatoes",
      },
    ],
  },
  {
    title: "SALATA / SALAD",
    items: [
      {
        name: "Sezonska salata s feta sirom / Seasonal salad with feta cheese",
        price: "6,00€",
        description: "",
        translation: "",
      },
      {
        name: "Sezonska salata / Seasonal salad",
        price: "5,50€",
        description: "",
        translation: "",
      },
      {
        name: "Cezar salata / Caesar salad",
        price: "12,00€",
        description: "zelena salata / piletina sa žara / cherry rajčica / hrskavi krutoni / cezar dressing / parmezan",
        translation: "green salad / grilled chicken / cherry tomato / crispy croutons / caesar dressing / parmesan cheese",
      },
    ],
  },
  {
    title: "ULJE / OIL",
    items: [
      {
        name: "Ulje od koštica grožđa, Vinarija Galić / Grape seed oil, Galić Winery",
        price: "bočica 100ml - 13,00€",
        description: "",
        translation: "",
      },
    ],
  },
  {
    title: "PRILOZI / SIDE DISHES",
    items: [
      {
        name: "Dollar chips",
        price: "4,00€",
        description: "",
        translation: "",
      },
      {
        name: "Kuhano povrće / Cooked vegetables",
        price: "4,00€",
        description: "",
        translation: "",
      },
      {
        name: "Pečeni krumpir / Baked potatoes",
        price: "4,00€",
        description: "",
        translation: "",
      },
      {
        name: "Pire krumpir / Mashed potatoes",
        price: "4,00€",
        description: "",
        translation: "",
      },
      {
        name: "Riža na maslacu / Butter rice",
        price: "4,00€",
        description: "",
        translation: "",
      },
      {
        name: "Domaći kruh / Homemade bread",
        price: "1,50€",
        description: "",
        translation: "",
      },
    ],
  },
  {
    title: "UMACI / SAUCE",
    items: [
      {
        name: "Umak od zelenog papra / Green pepper sauce",
        price: "4,00€",
        description: "",
        translation: "",
      },
      {
        name: "Umak od gorušice / Mustard sauce",
        price: "4,00€",
        description: "",
        translation: "",
      },
      {
        name: "Parmezan umak / Parmesan sauce",
        price: "4,00€",
        description: "",
        translation: "",
      },
      {
        name: "Ostali umaci / Other sauces",
        price: "2,00€",
        description: "",
        translation: "",
      },
    ],
  },
  {
    title: "DESERTI / DESSERTS",
    items: [
      {
        name: "Deserti dana 150g / Desserts of the day 150g",
        price: "6,00€",
        description: "",
        translation: "",
      },
    ],
  },
  {
    title: "PIĆA / DRINKS",
    subcategories: [
      {
        subtitle: "Rakije i likeri · Destilerija Aura / Schnapps & liqueurs · Aura Distillery",
        items: [
          {
            name: "Rakija od dunje / Quince schnapps",
            price: "0,03l - 2,90€",
            description: "",
            translation: "",
          },
          {
            name: "Šljivovica / Plum schnapps",
            price: "0,03l - 2,90€",
            description: "",
            translation: "",
          },
          {
            name: "Viljamovka / Gold pear schnapps",
            price: "0,03l - 2,90€",
            description: "",
            translation: "",
          },
          {
            name: "Medica / Medica (honey liqueur)",
            price: "0,03l - 2,90€",
            description: "",
            translation: "",
          },
          {
            name: "Rakija od maslina i badema / Olive and almond schnapps",
            price: "0,03l - 2,90€",
            description: "",
            translation: "",
          },
          {
            name: "Travarica / Herbal schnapps",
            price: "0,03l - 2,90€",
            description: "",
            translation: "",
          },
          {
            name: "Rakija od divlje kruške / Wild pear schnapps",
            price: "0,03l - 2,90€",
            description: "",
            translation: "",
          },
          {
            name: "Rakija od ruže / Rose schnapps",
            price: "0,03l - 2,90€",
            description: "",
            translation: "",
          },
          {
            name: "Limoncello",
            price: "0,03l - 2,90€",
            description: "",
            translation: "",
          },
          {
            name: "Teranino",
            price: "0,03l - 2,90€",
            description: "",
            translation: "",
          },
          {
            name: "Fernet Amaro 78",
            price: "0,03l - 2,90€",
            description: "",
            translation: "",
          },
        ],
      },
      {
        subtitle: "Destilerija Šoškić / Šoškić Distillery",
        items: [
          {
            name: "Pelinkovac Franz",
            price: "0,03l - 2,90€",
            description: "",
            translation: "",
          },
          {
            name: "Liker od zelene jabuke / Green apple liqueur",
            price: "0,03l - 2,90€",
            description: "",
            translation: "",
          },
          {
            name: "Liker od višnje / Cherry liqueur",
            price: "0,03l - 2,90€",
            description: "",
            translation: "",
          },
        ],
      },
      {
        subtitle: "Liker kuće / House liqueur",
        items: [
          {
            name: "Uzorita",
            price: "0,03l - 3,20€",
            description: "Liker od višnje maraske s okusom tartufa",
            translation: "Marasca cherry liqueur with truffle flavor",
          },
        ],
      },
      {
        subtitle: "Žestoka pića / Spirits",
        items: [
          {
            name: "Jack Daniels",
            price: "0,03l - 3,20€",
            description: "",
            translation: "",
          },
          {
            name: "Jägermeister",
            price: "0,03l - 3,00€",
            description: "",
            translation: "",
          },
          {
            name: "Pelinkovac Badel",
            price: "0,03l - 2,80€",
            description: "",
            translation: "",
          },
          {
            name: "Pelinkovac Antique",
            price: "0,03l - 2,90€",
            description: "",
            translation: "",
          },
          {
            name: "Prima Brand Badel",
            price: "0,03l - 2,80€",
            description: "",
            translation: "",
          },
          {
            name: "Malibu",
            price: "0,03l - 2,80€",
            description: "",
            translation: "",
          },
          {
            name: "Vodka Three Sixty",
            price: "0,03l - 2,80€",
            description: "",
            translation: "",
          },
          {
            name: "Rum Havana",
            price: "0,03l - 2,80€",
            description: "",
            translation: "",
          },
          {
            name: "Jameson Black Barrel",
            price: "0,03l - 4,50€",
            description: "",
            translation: "",
          },
          {
            name: "Whisky Ardbeg 10 YO",
            price: "0,03l - 7,50€",
            description: "",
            translation: "",
          },
          {
            name: "Rum Barcelo Imperijal",
            price: "0,03l - 3,50€",
            description: "",
            translation: "",
          },
          {
            name: "Gin Pennant, Destilerija Old Hils / Gin Pennant, Old Hils Distillery",
            price: "0,03l - 4,50€",
            description: "",
            translation: "",
          },
        ],
      },
      {
        subtitle: "Pjenušavo vino i cider / Sparkling wine & cider",
        items: [
          {
            name: "Pjenušac Galić Brut",
            price: "0,75l - 38,88€",
            description: "",
            translation: "",
          },
          {
            name: "Pjenušac Astoria Lounge",
            price: "0,75l - 20,88€",
            description: "",
            translation: "",
          },
          {
            name: "Somersby (jabuka / kruška / borovnica / jagoda / mandarina) / Somersby (apple / pear / blueberry / strawberry / tangerine)",
            price: "0,33l - 3,40€",
            description: "",
            translation: "",
          },
        ],
      },
      {
        subtitle: "Vino · Vinarija Galić / Wine · Galić Winery",
        items: [
          {
            name: "G Točka Crno",
            price: "0,75l - 18,88€ / 0,1l - 2,68€",
            description: "",
            translation: "",
          },
          {
            name: "Fjaka Babić",
            price: "0,75l - 29,88€ / 0,1l - 4,28€",
            description: "",
            translation: "",
          },
          {
            name: "Galić Pinot Noir",
            price: "0,75l - 42,00€",
            description: "",
            translation: "",
          },
          {
            name: "Galić Galileo premium graševina",
            price: "0,75l - 98,88€",
            description: "Limitirana serija od 1800 boca, proizvedeno u Galileo Oak bačvi, prvoj u Hrvatskoj, devetoj u svijetu",
            translation: "Limited series of 1800 bottles, produced in Galileo Oak barrels, the first in Croatia, the ninth in the world",
          },
          {
            name: "Graševina Galić",
            price: "0,75l - 27,88€ / 0,1l - 3,98€",
            description: "",
            translation: "",
          },
          {
            name: "Graševina kasna berba",
            price: "0,75l - 31,88€ / 0,1l - 4,58€",
            description: "",
            translation: "",
          },
          {
            name: "Sauvignon Blanc",
            price: "0,75l - 31,88€ / 0,1l - 4,58€",
            description: "",
            translation: "",
          },
          {
            name: "G Točka Bijela",
            price: "0,75l - 17,88€ / 0,1l - 2,58€",
            description: "",
            translation: "",
          },
          {
            name: "Chardonnay",
            price: "0,75l - 36,00€",
            description: "",
            translation: "",
          },
          {
            name: "Rose Galić",
            price: "0,75l - 27,88€ / 0,1l - 3,98€",
            description: "",
            translation: "",
          },
        ],
      },
      {
        subtitle: "Vino · Vinarija Deklić / Wine · Deklić Winery",
        items: [
          {
            name: "Cabernet Sauvignon",
            price: "0,75l - 35,00€",
            description: "",
            translation: "",
          },
          {
            name: "Teran",
            price: "0,75l - 35,00€",
            description: "",
            translation: "",
          },
          {
            name: "Merlot",
            price: "0,75l - 35,00€",
            description: "",
            translation: "",
          },
          {
            name: "Malvazija",
            price: "0,75l - 30,00€",
            description: "",
            translation: "",
          },
        ],
      },
      {
        subtitle: "Vino · Vinarija Šoškić i Vinarija Korlat / Wine · Šoškić Winery & Korlat Winery",
        items: [
          {
            name: "Muškat (Šoškić)",
            price: "0,75l - 29,00€ / 0,1l - 4,18€",
            description: "",
            translation: "",
          },
          {
            name: "Merlot boutique (Korlat)",
            price: "0,75l - 60,00€",
            description: "",
            translation: "",
          },
        ],
      },
      {
        subtitle: "PIVO / BEER",
        items: [
          {
            name: "Pan Lager",
            price: "0,5l - 3,20€",
            description: "",
            translation: "",
          },
          {
            name: "Pan Zlatni",
            price: "0,5l - 3,20€",
            description: "",
            translation: "",
          },
          {
            name: "Pan Radler",
            price: "0,5l - 3,20€",
            description: "",
            translation: "",
          },
          {
            name: "Pan bezalkoholno / Pan non-alcoholic",
            price: "0,5l - 3,20€",
            description: "",
            translation: "",
          },
          {
            name: "Tuborg",
            price: "0,5l - 3,20€ / 0,33l - 3,10€",
            description: "",
            translation: "",
          },
          {
            name: "Budweiser tamno / Budweiser dark",
            price: "0,5l - 3,40€",
            description: "",
            translation: "",
          },
          {
            name: "Budweiser",
            price: "0,5l - 3,40€ / 0,33l - 3,20€",
            description: "",
            translation: "",
          },
          {
            name: "Carlsberg",
            price: "0,33l - 3,20€ / 0,4l - 3,40€",
            description: "",
            translation: "",
          },
          {
            name: "Grimbergen",
            price: "0,33l - 4,10€",
            description: "",
            translation: "",
          },
          {
            name: "Blanc",
            price: "0,33l - 4,20€",
            description: "",
            translation: "",
          },
          {
            name: "Blanc točeno",
            price: "0,3l - 4,20€ / 0,5l - 4,50€",
            description: "",
            translation: "",
          },
        ],
      },
      {
        subtitle: "SOKOVI / JUICES",
        items: [
          {
            name: "Jamnica",
            price: "1l - 6,00€ / 0,1l - 0,70€",
            description: "",
            translation: "",
          },
          {
            name: "Jana izvorska",
            price: "0,75l - 5,00€",
            description: "",
            translation: "",
          },
          {
            name: "Sensation, razni okusi / Sensation, various flavours",
            price: "0,25l - 3,20€",
            description: "",
            translation: "",
          },
          {
            name: "Jana Vitamin, razni okusi / Jana Vitamin, various flavours",
            price: "0,33l - 3,20€",
            description: "",
            translation: "",
          },
          {
            name: "Tocco, razni okusi / Tocco, various flavours",
            price: "0,25l - 3,80€",
            description: "",
            translation: "",
          },
          {
            name: "Cedevita, razni okusi / Cedevita, various flavours",
            price: "0,25l - 2,50€",
            description: "",
            translation: "",
          },
          {
            name: "Twist ISO limun",
            price: "0,5l - 3,50€",
            description: "",
            translation: "",
          },
          {
            name: "Ledeni čaj, razni okusi / Iced tea, various flavours",
            price: "0,33l - 3,20€",
            description: "",
            translation: "",
          },
        ],
      },
      {
        subtitle: "GAZIRANI SOKOVI / SODAS",
        items: [
          {
            name: "Coca cola",
            price: "0,25l - 3,20€",
            description: "",
            translation: "",
          },
          {
            name: "Cocta & Cocta free",
            price: "0,275l - 3,20€",
            description: "",
            translation: "",
          },
          {
            name: "Coca cola zero",
            price: "0,25l - 3,20€",
            description: "",
            translation: "",
          },
          {
            name: "Fanta",
            price: "0,25l - 3,20€",
            description: "",
            translation: "",
          },
          {
            name: "Sprite",
            price: "0,25l - 3,20€",
            description: "",
            translation: "",
          },
          {
            name: "Schweppes Tangerina / Bitter Lemon / Tonic / Schweppes Tangerine / Bitter Lemon / Tonic",
            price: "0,25l - 3,20€",
            description: "",
            translation: "",
          },
          {
            name: "Red bull",
            price: "0,25l - 3,20€",
            description: "",
            translation: "",
          },
          {
            name: "Jamnica narančada / limunada / Jamnica orangeade / lemonade",
            price: "0,33l - 3,20€",
            description: "",
            translation: "",
          },
        ],
      },
      {
        subtitle: "POSEBNA PONUDA / SPECIAL OFFER",
        items: [
          {
            name: "Aperol spritz",
            price: "7,88€",
            description: "",
            translation: "",
          },
          {
            name: "Sunset G point",
            price: "7,88€",
            description: "bijelo vino Galić G točka, liker od bazge, liker od lubenice, mineralna voda, zlatna prašina",
            translation: "White wine Galić G točka, elderberry liqueur, watermelon liqueur, mineral water, gold dust",
          },
        ],
      },
      {
        subtitle: "TOPLI NAPITCI / HOT BEVERAGES",
        items: [
          {
            name: "Espresso",
            price: "2,00€",
            description: "",
            translation: "",
          },
          {
            name: "Kava s mlijekom / Coffee with milk",
            price: "2,20€",
            description: "",
            translation: "",
          },
          {
            name: "Nescafé classic, čokolada, kokos, vanilija / Nescafé classic, chocolate, coconut, vanilla",
            price: "2,20€",
            description: "",
            translation: "",
          },
          {
            name: "Bijela kava / White coffee",
            price: "2,30€",
            description: "",
            translation: "",
          },
          {
            name: "Franck Superiore čajevi s medom i limunom / Franck Superiore Tea with honey and lemon",
            price: "3,00€",
            description: "",
            translation: "",
          },
        ],
      },
      {
        subtitle: "CIGARE / CIGARS",
        items: [
          {
            name: "Davidoff Millenium Petit Corona",
            price: "1 kom. - 18,50€",
            description: "",
            translation: "",
          },
          {
            name: "Oliva Serie V Melanio Robusto",
            price: "1 kom. - 17,10€",
            description: "",
            translation: "",
          },
          {
            name: "Romeo Y Julieta No. 1 Tubos",
            price: "1 kom. - 24,00€",
            description: "",
            translation: "",
          },
          {
            name: "Davidoff Club Cigarillos",
            price: "1 kutija/pack (10 kom.) - 24,00€",
            description: "",
            translation: "",
          },
          {
            name: "Zino Nicaragua Robusto",
            price: "1 kom. - 9,30€",
            description: "",
            translation: "",
          },
          {
            name: "Oscar Valladares 2012 by Oscar Connecticut Short Robusto",
            price: "1 kom. - 9,90€",
            description: "",
            translation: "",
          },
          {
            name: "Cumpay Numero XV",
            price: "1 kom. - 13,10€",
            description: "",
            translation: "",
          },
        ],
      },
      {
        subtitle: "VISKI / WHISKY",
        items: [
          {
            name: "Jameson",
            price: "0,03l - 2,98€",
            description: "",
            translation: "",
          },
          {
            name: "Jameson Crested",
            price: "0,03l - 4,28€",
            description: "",
            translation: "",
          },
          {
            name: "Red Breast",
            price: "0,03l - 7,28€",
            description: "",
            translation: "",
          },
          {
            name: "Chivas 18y",
            price: "0,03l - 8,58€",
            description: "",
            translation: "",
          },
          {
            name: "Chivas 12y",
            price: "0,03l - 3,78€",
            description: "",
            translation: "",
          },
          {
            name: "Royal Salute",
            price: "0,03l - 19,88€",
            description: "",
            translation: "",
          },
          {
            name: "Whisky Aberlour 12y",
            price: "0,03l - 4,88€",
            description: "",
            translation: "",
          },
          {
            name: "Fuji Single Blended",
            price: "0,03l - 10,28€",
            description: "",
            translation: "",
          },
        ],
      },
      {
        subtitle: "RUM",
        items: [
          {
            name: "Havana 3y",
            price: "0,03l - 2,78€",
            description: "",
            translation: "",
          },
          {
            name: "Bumbu Original",
            price: "0,03l - 4,88€",
            description: "",
            translation: "",
          },
          {
            name: "Bumbu XO",
            price: "0,03l - 5,28€",
            description: "",
            translation: "",
          },
          {
            name: "La Hechicera Muscat",
            price: "0,03l - 6,88€",
            description: "",
            translation: "",
          },
        ],
      },
      {
        subtitle: "TEQUILA",
        items: [
          {
            name: "Olmeca Silver",
            price: "0,03l - 2,98€",
            description: "",
            translation: "",
          },
          {
            name: "Olmeca Altos",
            price: "0,03l - 3,68€",
            description: "",
            translation: "",
          },
          {
            name: "Codigo Tequila Rose",
            price: "0,03l - 9,28€",
            description: "",
            translation: "",
          },
        ],
      },
      {
        subtitle: "GIN",
        items: [
          {
            name: "Beefeater",
            price: "0,03l - 2,98€",
            description: "",
            translation: "",
          },
          {
            name: "Malfy",
            price: "0,03l - 3,28€",
            description: "",
            translation: "",
          },
          {
            name: "Monkey 47",
            price: "0,03l - 7,28€",
            description: "",
            translation: "",
          },
        ],
      },
      {
        subtitle: "VODKA",
        items: [
          {
            name: "Absolut",
            price: "0,03l - 2,98€",
            description: "",
            translation: "",
          },
        ],
      },
    ],
  },
];

const ITEMS_PER_PAGE = 1;

const Menu = () => {
  const [currentPage, setCurrentPage] = useState(0);
  const [isBubbleOpen, setIsBubbleOpen] = useState(false);
  const menuTopRef = useRef(null);

  const totalPages = Math.ceil(menuData.length / ITEMS_PER_PAGE);
  useEffect(() => {
    const closeOnOutsideClick = (e) => {
      if (
        !e.target.closest(".menu-bubble") &&
        !e.target.closest(".menu-title")
      ) {
        setIsBubbleOpen(false);
      }
    };
    document.addEventListener("click", closeOnOutsideClick);
    return () => document.removeEventListener("click", closeOnOutsideClick);
  }, []);


  const toggleBubble = () => {
    setIsBubbleOpen((prev) => !prev);
  };

  const jumpToSection = (index) => {
    setCurrentPage(index);
    setIsBubbleOpen(false);
    scrollToHeader();
  };

  const scrollToHeader = () => {
    setTimeout(() => {
      menuTopRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
      window.scrollBy(0, -15000); // Adjust the value to create space above the header
    }, 0);
  };

  const handlePrevious = () => {
    setCurrentPage((prevPage) => {
      const newPage = Math.max(prevPage - 1, 0);
      scrollToHeader();
      return newPage;
    });
  };

  const handleNext = () => {
    setCurrentPage((prevPage) => {
      const newPage = Math.min(prevPage + 1, totalPages - 1);
      scrollToHeader();
      return newPage;
    });
  };

  const handleReset = () => {
    setCurrentPage(0);
    scrollToHeader();
  };

  const getCurrentPageData = () => {
    const startIndex = currentPage * ITEMS_PER_PAGE;
    const endIndex = startIndex + ITEMS_PER_PAGE;
    return menuData.slice(startIndex, endIndex);
  };

  const formatTitle = (title) => {
    const parts = title.split(' / ');
    if (parts.length === 2) {
      return (
        <>
          {parts[0]} <span className="menu-item-slash">/</span><br className="title-break" />
          {parts[1]}
        </>
      );
    }
    return <>{title}</>;
  };

  const formatPrice = (price) => {
    const parts = price.split(' / ');
    return parts.map((part, index) => (
      <div key={index} className="menu-item-price-part">{part}</div>
    ));
  };

  return (
    <div id="menu" className="container menu-container">
      <div
        ref={menuTopRef}
        style={{ paddingTop: "100px", marginTop: "-100px" }}
      ></div>
      <div className="menu-header">
        <div className="menu-bubble-wrapper">
          <h1 onClick={toggleBubble} className="menu-title">
          Menu
        </h1>

          {isBubbleOpen && (
            <div className="menu-bubble">
              {menuData.map((sec, index) => (
                <div
                  key={index}
                  className="menu-bubble-item"
                  onClick={() => jumpToSection(index)}
                >
                  {sec.title}
                </div>
              ))}
            </div>
          )}
        </div>
        <img src={logo} alt="Vedi Logo" className="menu-logo" />
      </div>
      {getCurrentPageData().map((section, sectionIndex) => (
        <section key={sectionIndex} className="menu-section">
          <h2>{section.title}</h2>
          {section.items ? (
            <ul>
              {section.items.map((item, itemIndex) => (
                <li key={itemIndex} className="menu-item">
                  <div className="menu-item-line">
                    <span className="menu-item-name">
                      {formatTitle(item.name)}
                    </span>
                    <span className="menu-item-dots"></span>
                    <div className="menu-item-price">
                      {formatPrice(item.price)}
                    </div>
                  </div>
                  {item.description && (
                    <small>
                      <i>{item.description}</i>
                    </small>
                  )}
                  {item.translation && (
                    <small>
                      <i>{item.translation}</i>
                    </small>
                  )}
                </li>
              ))}
            </ul>
          ) : (
            section.subcategories.map((subcategory, subcategoryIndex) => (
              <div key={subcategoryIndex}>
                <h3>{subcategory.subtitle}</h3>
                <ul>
                  {subcategory.items.map((item, itemIndex) => (
                    <li key={itemIndex} className="menu-item">
                      <div className="menu-item-line">
                        <span className="menu-item-name">
                          {formatTitle(item.name)}
                        </span>
                        <span className="menu-item-dots"></span>
                        <div className="menu-item-price">
                          {formatPrice(item.price)}
                        </div>
                      </div>
                      {item.description && (
                        <small>
                          <i>{item.description}</i>
                        </small>
                      )}
                      {item.translation && (
                        <small>
                          <i>{item.translation}</i>
                        </small>
                      )}
                    </li>
                  ))}
                </ul>
              </div>
            ))
          )}
        </section>
      ))}
      <div className="pagination">
        <button onClick={handlePrevious} disabled={currentPage === 0}>
          Prethodna
        </button>
        <span>
          Stranica {currentPage + 1} od {totalPages}
        </span>
        <button onClick={handleNext} disabled={currentPage === totalPages - 1}>
          Slijedeća
        </button>
      </div>
      {currentPage !== 0 && (
        <div className="reset-button">
          <button onClick={handleReset}>Početna</button>
        </div>
      )}
    </div>
  );
};

export default Menu;
